import { render } from "./raw.vue?vue&type=template&id=2394290e&ts=true"
import script from "./raw.vue?vue&type=script&lang=ts"
export * from "./raw.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/raw.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2394290e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2394290e', __exports__)) {
    api.reload('2394290e', __exports__)
  }
  
  module.hot.accept("./raw.vue?vue&type=template&id=2394290e&ts=true", () => {
    api.rerender('2394290e', render)
  })

}


export default __exports__